import React from 'react';
import { SetupTab } from 'areas/shared/pages/setup';
import { CheckBox } from "fw/forms";
import { Col, FormGroup, Row, Button } from "react-bootstrap";
import { DocumentUpload } from "areas/shared/controls";
import * as FormManager from 'fw/forms/form/FormManager';
import * as App from 'modules/app/App';
import * as APIRoutes from 'modules/app/API';
import ReviewType from 'areas/shared/consts/ReviewType';
import { CommentsGrid, AdminAppIdHeader } from 'areas/shared/components';
import AppReviewToolbar from 'areas/admin/certification/shared/AppReviewToolbar';
import AdminStepToolbar from 'areas/admin/certification/shared/AdminStepToolbar';
import API from 'fw/system/API';
import * as ReportManager from 'modules/reports/ReportManager';
import { ActionButton } from 'fw/components'

class FinalRecomm extends SetupTab {
    initialForm() {
        return {
            rowVersion: null,
            reviewComment: ''
        }
    }

    updatePostData = (form, dirty) => {
        this.setState({ form });

        if (dirty === true) this.dirt()
    }

    privileges() {
        return {
            add: App.hasPrivilege("AdminSiteReviewAccess"),
            edit: App.hasPrivilege("AdminSiteReviewAccess")
        }
    }

    isEnabled(data) {
        return (!data.isReviewFinished && this.props.queueTypeCode === "STR") || App.hasPrivilege("AdminFullEditAccess");
    }

    urls() {
        return {
            completeCertification: APIRoutes.Admin.url("/appReview/completeCertification"),
            denyCertification: APIRoutes.Admin.url("/appReview/denyCertification"),
            get: APIRoutes.Admin.url('/siteReview/getFinalRecommendationInfo'),
            reviewCompleted: APIRoutes.Admin.url('/siteReview/reviewCompleted'),
            reviewNotQualified: APIRoutes.Admin.url('/siteReview/reviewNotQualified'),
            loadComments: APIRoutes.Admin.url("/appReview/getComments"),
            save: APIRoutes.Admin.url('/siteReview/saveFinalRecomendation')
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId
        }
    }

    saveRequest() {
        return {
            entityId: this.state.form.entityId,
            certificationId: this.state.form.certificationId,
            content: this.state.reviewComment,
            certificationKey: this.props.selectedId,
            rowVersion: this.state.form.rowVersion,
            videoAssesment: this.state.form.videoAssesment,
            videoAssesmentStorageToken: this.state.form.videoAssesmentStorageToken,
            videoAssesmentFileName: this.state.form.videoAssesmentFileName,
            reviewComment: this.state.reviewComment
        }
    }

    changeStatusReviewRequest() {
        return {
            entityId: this.state.form.entityId,
            certificationId: this.state.form.certificationId,
            certificationKey: this.props.selectedId,
            rowVersion: this.state.form.rowVersion,
            videoAssesment: this.state.form.videoAssesment,
            videoAssesmentStorageToken: this.state.form.videoAssesmentStorageToken,
            videoAssesmentFileName: this.state.form.videoAssesmentFileName,
            reviewComment: this.state.reviewComment
        }
    }

    reviewCompleted = () => {
        let url = this.urls().reviewCompleted;
        let rq = this.changeStatusReviewRequest();

        this.finishReview(rq, url);
    }

    reviewNotQualified = () => {
        let url = this.urls().reviewNotQualified;
        let rq = this.changeStatusReviewRequest();

        this.finishReview(rq, url);
    }

    loadComments = () => {
        let rq = {
            certificationId: this.state.form.certificationId,
            queueTypeCode: ReviewType.SITE_REVIEW.code,
        };

        new API().get(this.urls().loadComments, rq,
            {
                success: (r) => {
                    let form = this.state.form;
                    form.comments = r.data.comments;
                    form.canCompleteReview = r.data.canCompleteReview;

                    this.setState(form);
                }
            });
    }

    finishReview = (rq, url) => {
        new API().post(url, rq, {
            success: (r) => {
                this.setState({
                    title: (r.data && r.data.siteReviewTitle) || this.state.siteReviewTitle,
                    saving: false,
                    dirty: false,
                    rowVersion: r.data.rowVersion,
                    form: {
                        ...this.state.form,
                        ...r.data,
                        original: {
                            ...this.state.form,
                            ...r.data
                        }
                    }
                }, () => { if (r.data.shouldUpdateComments) this.loadComments() });

                this.afterSave(r.data.entityId);
                this.props.onSuccess(r.message);
                this.props.onSave(r.data.entityId);
                FormManager.reset();
            },
            error: r => {
                this.setState({ saving: false });
                this.props.onError(r.error);
            }
        })
    }

    handleReviewNotQualified = () => {
        const me = this;

        this.beforeSave(() => {
            me.reviewNotQualified();
        });
    }

    handleReviewCompleted = () => {
        const me = this;
        this.beforeSave(() => {
            me.reviewCompleted();
        });
    }

    handleUploadChange = (file, controlName) => {
        let form = this.state.form;
        form[controlName + "StorageToken"] = file.storageToken;
        form[controlName + "FileName"] = file.fileName;

        if (file.fileName !== null)
            form.videoAssesment = true;
        else
            form.videoAssesment = false;
            
        this.updatePostData(form, true);
    };

    handleAppReviewToolbar = (comments, canCompleteReview) => {
        this.handleUpdateComments(comments, canCompleteReview);
    }

    handleCommentsGrid = (comments) => {
        this.handleUpdateComments(comments, true);
    }

    handleCommentChange = (comment) => {
        this.dirt();
        this.setState({
            reviewComment: comment
        });
    }

    handleUpdateComments(comments, canCompleteReview) {
        let form = this.state.form;
        form.comments = comments;
        form.canCompleteReview = canCompleteReview;

        this.setState(form);
    }

    ready = () => {
        let form = this.state.form;

        if (form.videoAssesmentFileName != null)
            form.videoAssesment = true;
        else
            form.videoAssesment = false;
        
        this.updatePostData(form, false);

        this.focusControl && this.focusControl.focus();
    }

    handlePrint = () => {
        const rq = Object.assign({
            reportType: "SiteReviewFinalRecommendationReport",
            format: "PDF",
            parameters: {
                CertificationId: this.state.form.certificationId
            }
        });

        ReportManager.execute(rq);
    };

    afterSave = (entityId) => {
        // Clean Add Comment textbox
        this._commentsGrid.cleanComment();
        this.setState({ reviewComment: '' });
    }

    renderButtons = () => {
        return (
            <React.Fragment>
                <hr />
                <Row>
                    <Col md={6}>
                    </Col>
                    <Col md={2}>
                        <AppReviewToolbar
                            disabled={this.state.form.isReviewFinished}
                            queueTypeCode={'STR'}
                            reviewTypeCode={'FNR'}
                            comments={this.state.form.comments}
                            onFlagSave={this.handleAppReviewToolbar}
                            certificationKey={this.props.selectedId} />
                    </Col>
                    <Col md={2}>
                        {(this.state.privileges.edit) && <Button id="btnNotQualified" bsStyle="danger btn-block"
                            onClick={this.handleReviewNotQualified}
                            disabled={this.state.form.isReviewFinished}>Not Qualified</Button>}
                    </Col>
                    <Col md={2}>
                        {(this.state.privileges.edit) && <Button id="btnQualified" bsStyle="success btn-block"
                            onClick={this.handleReviewCompleted}
                            disabled={!this.state.form.canCompleteReview || this.state.form.isReviewFinished}>Qualified</Button>}
                    </Col>
                </Row>
                <hr style={{ marginTop: 5, marginBottom: 5 }} />
                <Row>
                    <Col md={12}>
                        {this.renderAdminStepToolbar()}
                    </Col>
                </Row>

            </React.Fragment>
        );
    }

    renderStatusCheckboxes() {
        var me = this;
        var reviewTypes = [
            ReviewType.CORPORATE_ID,
            ReviewType.CORPORATE_OWNERS,
            ReviewType.COMPANY_HISTORY,
            ReviewType.CAPITAL_CONTRIBUTION,
            ReviewType.OPERATION_CONTROL,
            ReviewType.EMPLOYEE_COMP,
            ReviewType.TOUR];

        var reviewTypesList = reviewTypes.map(function (reviewType) {
            return <React.Fragment>{me.renderStatusCheckbox(reviewType)}</React.Fragment>;
        });

        return (
            <Col md={12}>
                <Row>
                    {reviewTypesList}
                </Row>
            </Col>
        );
    }

    renderStatusCheckbox(reviewType) {
        const name = reviewType.systemName + "Completed";
        return (
            <Col md={4} lg={3}>
                <FormGroup>
                    <CheckBox inline name={name} label={reviewType.description} disabled="true" />
                </FormGroup>
            </Col>
        );
    }

    renderAdminStepToolbar = () => {       
        return (
            <AdminStepToolbar
                ref={(c) => { this._ast = c }}
                certificationKey={this.props.selectedId}
                reviewTypeCode={"STR"}
                queueTypeCode={"STR"}
                comments={this.state.form.comments}
                showCancel={false}
                showSave={false}
                setupProps={this.props.setupProps}
                handleTabSelect={this.props.handleTabSelect}
            />)
    }

    renderForm() {
        const me = this;
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        {this.props.queueTypeCode !== "STR" ?
                            <React.Fragment>
                                <h3 style={{ marginTop: "0px", position: "relative" }}>
                                    <AdminAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.setupProps.daysOpen} certificationType={this.state.form.certificationType} certificationStatus={this.state.form.certificationStatus} />
                                </h3>
                                <hr />
                                <h3 style={{ marginTop: "0px" }}>
                                    Online Form 1901
                                    {this.renderAdminStepToolbar()}
                                    <div className="pull-right"><ActionButton id="btnPrint" onClick={this.handlePrint} icon="print" bsSize="sm">Print</ActionButton></div>
                                </h3>
                                <hr />
                            </React.Fragment>
                        :
                            <React.Fragment>
                                <h3>
                                    {this.state.form.siteReviewTitle}
                                    {this.renderAdminStepToolbar()}
                                    <div className="pull-right"><ActionButton id="btnPrint" onClick={this.handlePrint} icon="print" bsSize="sm">Print</ActionButton></div>
                                </h3>
                                <hr />
                            </React.Fragment>
                        }
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={8}>
                                <h3 style={{ marginTop: "0px" }}>
                                    Final Recommendation
                                </h3>
                            </Col>
                            <Col md={4}>
                                <p class="small">&nbsp;</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <hr />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    {me.renderStatusCheckboxes()}
                </Row>
                {this.state.form !== null && this.state.form.assessmentTypeId === 2 ? ( //Assessment Type selected is video
                    <Row>
                        <Col md={6} lg={5}>
                            <FormGroup>
                                <CheckBox disabled inline name="videoAssesment" label="Video Assessment" />
                                <DocumentUpload
                                    storageToken={this.state.form.videoAssesmentStorageToken}
                                    fileName={this.state.form.videoAssesmentFileName}
                                    onChange={(file) => this.handleUploadChange(file, "videoAssesment")}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                ):null}
                <Row>
                    <CommentsGrid
                        ref={(c) => { this._commentsGrid = c }}
                        comments={this.state.form.comments}
                        documents={this.state.form.reviewDocuments}
                        certificationKey={this.props.selectedId}
                        reviewTypeCode={"STR"}
                        queueTypeCode={"STR"}
                        enableExport={true}
                        entityId={this.state.form.entityId}
                        readonly={!this.state.privileges.edit || !this.state.enabled}
                        onSave={this.handleCommentsGrid}
                        onCommentChange={this.handleCommentChange}
                        showAddButton={true} />
                </Row>
            </React.Fragment>
        )
    }
}

export default FinalRecomm;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/siteReview/siteReviewInfo/finalRecomm/FinalRecomm.js